import React, { useState, useEffect } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Plus, Trash2, Pencil, Truck, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", contact: "", phone: "", email: "", notes: "" };

export default function Fornitori() {
  const { canWrite } = useAuth();
  const [list, setList] = useState([]);
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/suppliers").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name.trim()) return toast.error("Inserisci il nome del fornitore");
    setSaving(true);
    try {
      await api.post("/suppliers", form);
      toast.success("Fornitore salvato");
      setForm(null);
      load();
    } catch (e) { toast.error("Errore nel salvataggio"); }
    finally { setSaving(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare questo fornitore?")) return;
    await api.delete(`/suppliers/${id}`);
    load();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-head text-3xl font-bold tracking-tight text-navy">Fornitori</h1>
          <p className="text-slate-500">Anagrafica fornitori di bordo</p>
        </div>
        {canWrite && (
          <button data-testid="add-supplier-btn" onClick={() => setForm({ ...empty })} className="flex h-14 items-center gap-2 rounded-xl bg-navy px-5 font-semibold text-white hover:bg-navy-hover">
            <Plus className="h-5 w-5" /> Nuovo
          </button>
        )}
      </div>

      {list.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white py-16 text-center">
          <Truck className="mx-auto mb-3 h-10 w-10 text-slate-300" />
          <p className="text-slate-400">Nessun fornitore ancora. Aggiungine uno.</p>
        </div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((s) => (
            <div key={s.id} data-testid={`supplier-${s.id}`} className="rounded-xl border border-slate-200 bg-white p-5">
              <div className="flex items-start justify-between">
                <div className="font-head text-lg font-semibold text-navy">{s.name}</div>
                {canWrite && (
                  <div className="flex gap-1">
                    <button onClick={() => setForm(s)} className="rounded p-1.5 text-slate-400 hover:bg-slate-100"><Pencil className="h-4 w-4" /></button>
                    <button data-testid={`delete-supplier-${s.id}`} onClick={() => remove(s.id)} className="rounded p-1.5 text-red-400 hover:bg-red-50"><Trash2 className="h-4 w-4" /></button>
                  </div>
                )}
              </div>
              {s.contact && <p className="mt-1 text-sm text-slate-600">{s.contact}</p>}
              {s.phone && <p className="text-sm text-slate-500">{s.phone}</p>}
              {s.email && <p className="text-sm text-slate-500">{s.email}</p>}
              {s.notes && <p className="mt-2 text-xs text-slate-400">{s.notes}</p>}
            </div>
          ))}
        </div>
      )}

      {form && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 sm:items-center">
          <div className="animate-slide-up w-full max-w-md rounded-t-2xl bg-white p-6 sm:rounded-2xl">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="font-head text-xl font-bold text-navy">{form.id ? "Modifica" : "Nuovo"} fornitore</h3>
              <button onClick={() => setForm(null)}><X className="h-6 w-6 text-slate-400" /></button>
            </div>
            <div className="space-y-3">
              {[["name", "Nome *"], ["contact", "Referente"], ["phone", "Telefono"], ["email", "Email"], ["notes", "Note"]].map(([k, l]) => (
                <div key={k}>
                  <label className="mb-1 block text-sm font-semibold text-navy">{l}</label>
                  <input data-testid={`supplier-${k}`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="h-12 w-full rounded-lg border-2 border-slate-200 px-3 outline-none focus:border-gold" />
                </div>
              ))}
            </div>
            <button data-testid="save-supplier-btn" onClick={save} disabled={saving} className="mt-5 flex h-14 w-full items-center justify-center gap-2 rounded-lg bg-gold font-bold text-black hover:bg-gold-hover disabled:opacity-60">
              {saving && <Loader2 className="h-5 w-5 animate-spin" />} Salva
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
